var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaBusinessPartner2026({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 40,
    viewBox: "0 0 84 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6281",
    "data-name": "Path 6281",
    d: "M228.136,237.93c-1.737,0-3.093,1.307-4.324,2.969-1.688-2.15-3.1-2.969-4.789-2.969-3.445,0-6.083,4.482-6.083,9.235,0,2.969,1.435,4.842,3.835,4.842,1.733,0,2.979-.818,5.194-4.687l1.557-2.755c.223.36.455.747.7,1.161l1.038,1.747c2.022,3.386,3.15,4.534,5.19,4.534,2.345,0,3.648-1.9,3.648-4.93C234.112,242.1,231.414,237.93,228.136,237.93Zm-7.852,8.337c-1.79,2.812-2.416,3.443-3.414,3.443s-1.642-.9-1.642-2.514c0-3.445,1.719-6.968,3.765-6.968,1.107,0,2.045.642,3.455,2.673C221.1,244.969,220.284,246.267,220.284,246.267Zm6.775-.357-1.241-2.068q-.511-.816-.97-1.508c1.118-1.726,2.045-2.587,3.14-2.587,2.279,0,4.092,3.359,4.092,7.481,0,1.573-.512,2.485-1.583,2.485C229.489,249.724,229,249.036,227.059,245.91Z",
    transform: "translate(-212.94 -237.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 23.73,
    height: 16.627,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4147",
    "data-name": "Group 4147",
    transform: "translate(-342.247 -541.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4134",
    "data-name": "Group 4134",
    transform: "translate(348.857 548.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M356.7,240.49h2.646l4.5,8.139,4.5-8.139h2.591v13.383h-2.161V243.612l-3.946,7.1h-2.02l-3.951-7.1v10.261H356.7Z",
    transform: "translate(-331.069 -240.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M452.318,268.693a5.151,5.151,0,0,1-2.637-.661,4.672,4.672,0,0,1-1.772-1.838,5.581,5.581,0,0,1-.635-2.7,5.769,5.769,0,0,1,.619-2.723,4.624,4.624,0,0,1,1.726-1.851,4.772,4.772,0,0,1,2.537-.67,4.193,4.193,0,0,1,4.029,2.557,6.772,6.772,0,0,1,.555,2.849v.59h-7.326a3.185,3.185,0,0,0,.99,1.926,2.878,2.878,0,0,0,1.992.7,4.372,4.372,0,0,0,1.662-.289,4.189,4.189,0,0,0,1.309-.87l1.145,1.407A5.958,5.958,0,0,1,452.318,268.693Zm1.578-7.925a2.377,2.377,0,0,0-1.79-.694,2.459,2.459,0,0,0-1.79.706,3.322,3.322,0,0,0-.913,1.9h5.267a2.976,2.976,0,0,0-.772-1.92Z",
    transform: "translate(-405.494 -254.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M505.91,247.9h-1.99v-1.767h1.99V243.21h2.081v2.926h3.017V247.9H507.99v4.477a2.593,2.593,0,0,0,.382,1.6,1.563,1.563,0,0,0,1.309.476,6.107,6.107,0,0,0,.7-.034c.193-.02.4-.052.629-.089v1.747a6.017,6.017,0,0,1-.8.175,6.27,6.27,0,0,1-.932.066q-3.372,0-3.37-3.687Z",
    transform: "translate(-452.041 -242.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M559.122,268.52h-2.045v-1.394a3.693,3.693,0,0,1-1.385,1.207,4.165,4.165,0,0,1-1.909.424,4.12,4.12,0,0,1-2.334-.672,4.593,4.593,0,0,1-1.6-1.854,6,6,0,0,1-.583-2.7,5.885,5.885,0,0,1,.594-2.7,4.578,4.578,0,0,1,1.637-1.844,4.356,4.356,0,0,1,2.4-.67,4.121,4.121,0,0,1,1.833.4,3.61,3.61,0,0,1,1.348,1.113v-1.278h2.045v9.974Zm-2.084-6.477a2.83,2.83,0,0,0-1.055-1.343,2.873,2.873,0,0,0-1.667-.49,2.7,2.7,0,0,0-2.131.9,3.557,3.557,0,0,0-.793,2.427,3.617,3.617,0,0,0,.767,2.434,2.577,2.577,0,0,0,2.074.9,3.051,3.051,0,0,0,1.719-.512,2.784,2.784,0,0,0,1.089-1.337Z",
    transform: "translate(-489.3 -254.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4127",
    "data-name": "Group 4127",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4129",
    "data-name": "Group 4129",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4128",
    "data-name": "Group 4128",
    transform: "translate(-1.278 -1.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4127-2",
    "data-name": "Group 4127",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 23.811,
    height: 16.692,
    transform: "translate(-0.018 -0.048)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M253.725,243.842c-2.692-4.381-4.484-5.912-6.8-5.912l-.029,2.3c1.514,0,2.687,1.195,5.24,5.491l.155.255Z",
    transform: "translate(-240.845 -237.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4135",
    "data-name": "Group 4135",
    transform: "translate(1.559 19.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6283",
    "data-name": "Path 6283",
    d: "M211.83,362.983V356.65h2.377a2.938,2.938,0,0,1,1.164.193,1.492,1.492,0,0,1,.686.592,1.557,1.557,0,0,1,.248.836,1.426,1.426,0,0,1-.221.765,1.593,1.593,0,0,1-.665.579,1.645,1.645,0,0,1,.883.574,1.544,1.544,0,0,1,.308.959,1.857,1.857,0,0,1-.187.827,1.611,1.611,0,0,1-.464.59,1.931,1.931,0,0,1-.694.314,4.184,4.184,0,0,1-1.022.105H211.83Zm.838-3.671h1.369a3.092,3.092,0,0,0,.8-.073.834.834,0,0,0,.644-.868,1.006,1.006,0,0,0-.152-.555.763.763,0,0,0-.431-.328,3.605,3.605,0,0,0-.963-.089h-1.266Zm0,2.924h1.576a3.712,3.712,0,0,0,.571-.03,1.351,1.351,0,0,0,.483-.173.914.914,0,0,0,.319-.351,1.1,1.1,0,0,0,.125-.533,1.048,1.048,0,0,0-.182-.615.961.961,0,0,0-.5-.367,3.1,3.1,0,0,0-.927-.105h-1.464v2.175Z",
    transform: "translate(-211.83 -356.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M249.774,371.011v-.674a1.677,1.677,0,0,1-1.457.777,1.853,1.853,0,0,1-.758-.155,1.243,1.243,0,0,1-.522-.39,1.437,1.437,0,0,1-.239-.578,3.9,3.9,0,0,1-.048-.726v-2.842h.777v2.544a4.464,4.464,0,0,0,.048.82.809.809,0,0,0,.31.481.971.971,0,0,0,.588.175,1.276,1.276,0,0,0,.656-.18.984.984,0,0,0,.433-.489,2.442,2.442,0,0,0,.127-.9V366.42h.777v4.587h-.694Z",
    transform: "translate(-241.11 -364.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6285",
    "data-name": "Path 6285",
    d: "M272.7,369.165l.768-.121a1.075,1.075,0,0,0,.36.708,1.258,1.258,0,0,0,.827.246,1.223,1.223,0,0,0,.8-.218.651.651,0,0,0,.259-.512.477.477,0,0,0-.228-.415,3.362,3.362,0,0,0-.8-.264,7.216,7.216,0,0,1-1.186-.374,1.135,1.135,0,0,1-.672-1.052,1.174,1.174,0,0,1,.141-.569,1.279,1.279,0,0,1,.382-.435,1.618,1.618,0,0,1,.494-.226,2.336,2.336,0,0,1,.672-.093,2.665,2.665,0,0,1,.949.155,1.291,1.291,0,0,1,.6.421,1.623,1.623,0,0,1,.267.711l-.76.1a.827.827,0,0,0-.3-.553,1.1,1.1,0,0,0-.7-.2,1.278,1.278,0,0,0-.765.176.513.513,0,0,0-.228.415.437.437,0,0,0,.094.273.675.675,0,0,0,.3.207c.078.029.307.095.686.2a9.578,9.578,0,0,1,1.152.36,1.17,1.17,0,0,1,.512.408,1.143,1.143,0,0,1,.185.665,1.308,1.308,0,0,1-.226.733,1.468,1.468,0,0,1-.654.531,2.393,2.393,0,0,1-.968.187,2.153,2.153,0,0,1-1.362-.371A1.708,1.708,0,0,1,272.7,369.165Z",
    transform: "translate(-262.433 -364.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6286",
    "data-name": "Path 6286",
    d: "M299.28,357.545v-.9h.777v.9Zm0,5.438V358.4h.777v4.587Z",
    transform: "translate(-284.274 -356.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6287",
    "data-name": "Path 6287",
    d: "M310.27,370.551v-4.587h.7v.652a1.648,1.648,0,0,1,1.46-.756,1.91,1.91,0,0,1,.763.15,1.213,1.213,0,0,1,.521.39,1.493,1.493,0,0,1,.242.574,4.5,4.5,0,0,1,.043.756v2.821h-.777v-2.79a2.1,2.1,0,0,0-.091-.711.75.75,0,0,0-.323-.376,1.031,1.031,0,0,0-.542-.141,1.259,1.259,0,0,0-.858.316,1.556,1.556,0,0,0-.36,1.2v2.505h-.777Z",
    transform: "translate(-293.305 -364.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6288",
    "data-name": "Path 6288",
    d: "M339.82,369.075l.8.1a1.962,1.962,0,0,1-.7,1.093,2.122,2.122,0,0,1-1.314.389,2.1,2.1,0,0,1-1.6-.62,2.419,2.419,0,0,1-.59-1.738,2.534,2.534,0,0,1,.6-1.8,2.018,2.018,0,0,1,1.546-.64,1.961,1.961,0,0,1,1.5.626,2.488,2.488,0,0,1,.583,1.762c0,.046,0,.116,0,.207h-3.421a1.756,1.756,0,0,0,.428,1.157,1.274,1.274,0,0,0,.959.4,1.2,1.2,0,0,0,.731-.225A1.473,1.473,0,0,0,339.82,369.075Zm-2.553-1.257h2.562a1.543,1.543,0,0,0-.294-.868,1.192,1.192,0,0,0-.963-.449,1.234,1.234,0,0,0-.9.358A1.41,1.41,0,0,0,337.267,367.818Z",
    transform: "translate(-314.793 -364.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6289",
    "data-name": "Path 6289",
    d: "M363.72,369.165l.768-.121a1.075,1.075,0,0,0,.36.708,1.258,1.258,0,0,0,.827.246,1.223,1.223,0,0,0,.8-.218.651.651,0,0,0,.259-.512.477.477,0,0,0-.228-.415,3.362,3.362,0,0,0-.8-.264,7.215,7.215,0,0,1-1.186-.374,1.135,1.135,0,0,1-.672-1.052,1.175,1.175,0,0,1,.141-.569,1.28,1.28,0,0,1,.382-.435,1.619,1.619,0,0,1,.494-.226,2.336,2.336,0,0,1,.672-.093,2.665,2.665,0,0,1,.948.155,1.291,1.291,0,0,1,.6.421,1.624,1.624,0,0,1,.267.711l-.759.1a.827.827,0,0,0-.3-.553,1.1,1.1,0,0,0-.7-.2,1.278,1.278,0,0,0-.765.176.513.513,0,0,0-.228.415.437.437,0,0,0,.094.273.675.675,0,0,0,.3.207c.078.029.307.095.686.2a9.58,9.58,0,0,1,1.152.36,1.17,1.17,0,0,1,.512.408,1.143,1.143,0,0,1,.185.665,1.308,1.308,0,0,1-.226.733,1.468,1.468,0,0,1-.654.531,2.393,2.393,0,0,1-.968.187,2.152,2.152,0,0,1-1.362-.371A1.724,1.724,0,0,1,363.72,369.165Z",
    transform: "translate(-337.225 -364.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6290",
    "data-name": "Path 6290",
    d: "M388.53,369.165l.768-.121a1.075,1.075,0,0,0,.36.708,1.258,1.258,0,0,0,.827.246,1.223,1.223,0,0,0,.8-.218.651.651,0,0,0,.259-.512.477.477,0,0,0-.228-.415,3.36,3.36,0,0,0-.8-.264,7.217,7.217,0,0,1-1.186-.374,1.135,1.135,0,0,1-.672-1.052,1.174,1.174,0,0,1,.141-.569,1.278,1.278,0,0,1,.382-.435,1.618,1.618,0,0,1,.494-.226,2.336,2.336,0,0,1,.672-.093,2.665,2.665,0,0,1,.949.155,1.292,1.292,0,0,1,.6.421,1.623,1.623,0,0,1,.267.711l-.759.1a.827.827,0,0,0-.3-.553,1.1,1.1,0,0,0-.7-.2,1.278,1.278,0,0,0-.765.176.513.513,0,0,0-.228.415.437.437,0,0,0,.094.273.675.675,0,0,0,.3.207c.078.029.307.095.686.2a9.578,9.578,0,0,1,1.152.36,1.171,1.171,0,0,1,.512.408,1.143,1.143,0,0,1,.185.665,1.308,1.308,0,0,1-.226.733,1.468,1.468,0,0,1-.654.531,2.393,2.393,0,0,1-.968.187,2.152,2.152,0,0,1-1.362-.371A1.724,1.724,0,0,1,388.53,369.165Z",
    transform: "translate(-357.612 -364.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6291",
    "data-name": "Path 6291",
    d: "M432.22,362.983V356.65h2.389a5.675,5.675,0,0,1,.963.061,1.894,1.894,0,0,1,.783.3,1.561,1.561,0,0,1,.508.612,2.063,2.063,0,0,1-.321,2.232,2.468,2.468,0,0,1-1.858.56H433.06v2.575h-.84Zm.838-3.322h1.637a1.727,1.727,0,0,0,1.154-.3,1.074,1.074,0,0,0,.341-.85,1.148,1.148,0,0,0-.2-.681.938.938,0,0,0-.53-.374,3.561,3.561,0,0,0-.783-.057h-1.621v2.266Z",
    transform: "translate(-393.512 -356.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6292",
    "data-name": "Path 6292",
    d: "M467.1,369.994a2.922,2.922,0,0,1-.831.519,2.423,2.423,0,0,1-.858.152,1.669,1.669,0,0,1-1.162-.369,1.219,1.219,0,0,1-.406-.943,1.282,1.282,0,0,1,.554-1.063,1.867,1.867,0,0,1,.56-.255,5.424,5.424,0,0,1,.692-.118,7.164,7.164,0,0,0,1.387-.267c0-.107,0-.175,0-.2a.857.857,0,0,0-.221-.67,1.305,1.305,0,0,0-.886-.264,1.368,1.368,0,0,0-.809.193,1.174,1.174,0,0,0-.387.681l-.76-.1a1.91,1.91,0,0,1,.341-.788,1.491,1.491,0,0,1,.686-.462,3.047,3.047,0,0,1,1.041-.162,2.731,2.731,0,0,1,.954.139,1.276,1.276,0,0,1,.54.348,1.212,1.212,0,0,1,.242.53,4.461,4.461,0,0,1,.039.717v1.036a10.83,10.83,0,0,0,.05,1.371,1.761,1.761,0,0,0,.2.551h-.811A1.676,1.676,0,0,1,467.1,369.994Zm-.064-1.737a5.639,5.639,0,0,1-1.269.294,2.978,2.978,0,0,0-.677.155.675.675,0,0,0-.307.253.686.686,0,0,0,.127.888,1.019,1.019,0,0,0,.69.207,1.612,1.612,0,0,0,.8-.2,1.2,1.2,0,0,0,.513-.538,1.871,1.871,0,0,0,.125-.777Z",
    transform: "translate(-419.495 -364.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4132",
    "data-name": "Group 4132",
    transform: "translate(49.453 1.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6293",
    "data-name": "Path 6293",
    d: "M492.49,370.551v-4.587h.7v.7a1.919,1.919,0,0,1,.494-.644.865.865,0,0,1,.5-.155,1.513,1.513,0,0,1,.8.251l-.267.722a1.115,1.115,0,0,0-.571-.169.747.747,0,0,0-.458.153.823.823,0,0,0-.289.426,3.058,3.058,0,0,0-.13.908v2.4h-.777Z",
    transform: "translate(-492.49 -365.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6294",
    "data-name": "Path 6294",
    d: "M511.765,362.953l.112.686a2.875,2.875,0,0,1-.588.07,1.33,1.33,0,0,1-.656-.134.749.749,0,0,1-.328-.351,2.767,2.767,0,0,1-.095-.918v-2.639h-.571v-.6h.571v-1.136l.774-.467v1.6h.783v.6h-.783v2.683a1.385,1.385,0,0,0,.041.428.315.315,0,0,0,.134.152.516.516,0,0,0,.266.057A3.137,3.137,0,0,0,511.765,362.953Z",
    transform: "translate(-457.129 -357.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6295",
    "data-name": "Path 6295",
    d: "M525.83,370.551v-4.587h.7v.652a1.648,1.648,0,0,1,1.46-.756,1.91,1.91,0,0,1,.763.15,1.214,1.214,0,0,1,.521.39,1.493,1.493,0,0,1,.242.574,4.492,4.492,0,0,1,.043.756v2.821h-.777v-2.79a2.1,2.1,0,0,0-.091-.711.75.75,0,0,0-.323-.376,1.032,1.032,0,0,0-.542-.141,1.259,1.259,0,0,0-.858.316,1.556,1.556,0,0,0-.36,1.2v2.505h-.777Z",
    transform: "translate(-470.433 -364.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6296",
    "data-name": "Path 6296",
    d: "M555.37,369.075l.8.1a1.962,1.962,0,0,1-.7,1.093,2.122,2.122,0,0,1-1.314.389,2.1,2.1,0,0,1-1.6-.62,2.426,2.426,0,0,1-.59-1.738,2.533,2.533,0,0,1,.6-1.8,2.018,2.018,0,0,1,1.546-.64,1.961,1.961,0,0,1,1.5.626,2.488,2.488,0,0,1,.583,1.762c0,.046,0,.116,0,.207h-3.421a1.755,1.755,0,0,0,.428,1.157,1.274,1.274,0,0,0,.959.4,1.2,1.2,0,0,0,.731-.225A1.46,1.46,0,0,0,555.37,369.075Zm-2.553-1.257h2.562a1.543,1.543,0,0,0-.294-.868,1.191,1.191,0,0,0-.963-.449,1.234,1.234,0,0,0-.9.358A1.41,1.41,0,0,0,552.817,367.818Z",
    transform: "translate(-491.912 -364.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6297",
    "data-name": "Path 6297",
    d: "M580.97,370.551v-4.587h.7v.7a1.92,1.92,0,0,1,.494-.644.865.865,0,0,1,.5-.155,1.513,1.513,0,0,1,.8.251l-.267.722a1.115,1.115,0,0,0-.57-.169.747.747,0,0,0-.458.153.823.823,0,0,0-.289.426,3.058,3.058,0,0,0-.13.908v2.4h-.776Z",
    transform: "translate(-515.742 -364.218)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    transform: "translate(342.247 541.179)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 39,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaBusinessPartner2026);
export default __webpack_public_path__ + "static/media/Meta-Business-Partner-2026.a30652c5438e7e61075d683b7bf85e71.svg";
export { ForwardRef as ReactComponent };